import { createContext, useContext } from "react";

export const AuthContext = createContext();

// export const AuthProvider = (props) => {
//   const [loggedIn, setLoggedIn] = useState(false);
//   const [authTokens, setAuthTokens] = useState(existingTokens);
//   const [existingTokens, setExistingTokens] = useState();

//   useEffect(() => {
//     setExistingTokens(JSON.parse(localStorage.getItem("tokens")));
//   }, []);

//   const setTokens = (data) => {
//     localStorage.setItem("tokens", JSON.stringify(data));
//     setAuthTokens(data);
//   };

//   const login = (values) => {
//     axios({
//       method: "post",
//       url: "auth/signin",
//       data: {
//         password: values.password,
//         username: values.username,
//       },
//     })
//       .then((result) => {
//         if (result.status === 200) {
//           console.log(result);
//           setAuthTokens(result.data);
//           setRol(result.data.rol[0]);
//           setLoggedIn(true);
//         } else if (result.status === 400) {
//           toast.error(
//             result.errors[0].field + " " + result.errors[0].defaultMessage
//           );
//         } else toast.error(result.message);
//       })
//       .catch((e) => {
//         toast.dismiss();
//         toast.error(e.response.data.message);
//       });
//   };
//   const logout = () => {};

//   const authContextValue = { login, loggedIn, logout };
//   return <AuthProvider value={authContextValue} {...props} />;
// };

export function useAuth() {
  return useContext(AuthContext);
}
